module.exports = __webpack_public_path__ + "media/images/office_2-dd114933d1b0273ecf251c2d1586c8d1.jpg";